<div class="flex flex-col gap-4">
  <app-dropdown
    [field]="itemTree"
    [id]="itemField().id"
    [label]="itemField().label"
    [placeholder]="itemField().placeholder"
    [options]="itemField().options" />
  <app-dropdown
    [field]="standardTree"
    [id]="standardField().id"
    [label]="standardField().label"
    [placeholder]="standardField().placeholder"
    [options]="standardField().options" />

  <div class="rounded-lg bg-utility-gray-50 p-4 flex flex-col gap-2">
    @if (compositeValue(); as value) {
      @let breadcrumb = breadcrumbParts();
      <p class="text-sm text-secondary m-0" data-testid="vsp-breadcrumb">
        {{ breadcrumb.path
        }}<span class="font-semibold"
          >{{ breadcrumb.last }} {{ value.title }}</span
        >
      </p>
      <div class="flex items-center gap-2 flex-wrap">
        <span
          class="chip chip-xs"
          [class.chip-orange]="value.critical"
          [class.chip-warning]="!value.critical"
          data-testid="vsp-points-badge"
          >{{ pointsBadge(value) }}</span
        >
      </div>
      @if (value.section) {
        <app-expandable-text [text]="value.description" />
      } @else if (!state().disabled()) {
        <p class="m-0 text-secondary">{{ standardPrompt }}</p>
      }
    } @else {
      <p class="m-0 text-secondary">{{ placeholderText }}</p>
    }
  </div>
</div>
